import React, { lazy, Suspense, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Preloader from "../Miscellaneous/Preloader";

const solutionComponents = {
  "vehicle-engineering": lazy(() => import("./Solutions1")),
  "sales-and-marketing": lazy(() => import("./Solutions2")),
  "after-sales-and-customer-service": lazy(() => import("./Solutions3")),
  "fleet-management": lazy(() => import("./Solutions4")),
  "quality": lazy(() => import("./Solutions5")),
  "regulatory-and-sustainability": lazy(() => import("./Solutions6")),
};

const DynamicSolution = () => {
  const { solutionName } = useParams();
  const location = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }, [location.pathname]);

  const DecodedName = decodeURIComponent(solutionName);

  const Component = solutionComponents[DecodedName];

  return (
    <Suspense fallback={<Preloader />}>
      {Component ? <Component /> : <div>Solution not found</div>}
    </Suspense>
  );
};

export default DynamicSolution;
